module.exports = __webpack_public_path__ + "img/lalmai_lakeland.dfbef49a.png";